var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "ci-user-profile-articles ci-content-padding-as-body-x" },
    [
      !_vm.loading || (_vm.articles && _vm.articles.length > 0)
        ? [
            _vm.articles && _vm.articles.length > 0
              ? [
                  _c(
                    "div",
                    { staticClass: "row no-gutters-handheld" },
                    _vm._l(_vm.articles, function (article) {
                      return _c(
                        "div",
                        { staticClass: "col-12 col-md-6 col-xl-4 d-flex" },
                        [
                          _c("ci-content-tile", {
                            staticClass: "mb-2 mb-md-3 w-100",
                            attrs: { "tile-data": article },
                          }),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  _c("div", {
                    directives: [
                      {
                        name: "ci-is-in-viewport",
                        rawName: "v-ci-is-in-viewport",
                        value: "article_lazyload",
                        expression: "'article_lazyload'",
                      },
                    ],
                    staticClass: "iiv",
                  }),
                ]
              : _vm.owner
              ? [
                  _vm.communityManager
                    ? _c("ci-direct-message-modal", {
                        attrs: {
                          "user-id": _vm.communityManager.id,
                          "modal-id": _vm.modalId,
                        },
                      })
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass:
                        "ci-card ci-section ci-content-padding text-muted",
                    },
                    [
                      _c("p", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t(
                              "ui.components.users.profile.articles.empty_state"
                            )
                          ),
                        },
                      }),
                      _c(
                        "div",
                        { staticClass: "row flex-center" },
                        [
                          _c("ci-button", {
                            directives: [
                              {
                                name: "b-modal",
                                rawName: "v-b-modal",
                                value: _vm.modalId,
                                expression: "modalId",
                              },
                            ],
                            attrs: {
                              icon: "mdi-plus",
                              label: _vm.$t(
                                "ui.components.users.profile.articles.action"
                              ),
                              variant: "outline-primary",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }